import { useState } from "react";
import { CheckCheck, BellOff, Trash2, Volume2, VolumeX } from "lucide-react";
import { playChime, setSoundOn, soundOn } from "@/lib/notifySound";
import { Loader } from "@/components/ui-helpers";
import { NotificationFeed, NotificationFilters } from "@/components/NotificationFeed";
import { usePagedNotifications } from "@/hooks/usePagedNotifications";
import { useNavigate } from "react-router-dom";
import { openNotification } from "@/lib/notifications";

export default function MobileNotifications() {
  const n = usePagedNotifications();
  const nav = useNavigate();
  const [sound, setSound] = useState(soundOn());
  const toggleSound = () => { const next = !sound; setSoundOn(next); setSound(next); if (next) playChime(true); };
  const open = (x) => { n.markLocal(x); openNotification(x, nav, { mobile: true }); };
  if (!n.data) return <Loader />;
  const empty = !n.data.items.length && !n.filter.unread && !n.filter.cat;

  return (
    <div className="p-4 space-y-3" data-testid="mobile-notifications">
      <div className="flex items-center justify-between gap-2">
        <h1 className="font-head font-extrabold text-xl text-slate-900">Notifications</h1>
        <div className="flex gap-3 items-center">
          <button onClick={toggleSound} data-testid="mobile-notif-sound-toggle" className={`text-xs font-semibold inline-flex items-center gap-1 ${sound ? "text-primary" : "text-slate-400"}`}>{sound ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />} Sound</button>
          {n.data.unread > 0 && <button onClick={n.markAll} data-testid="notif-mark-all" className="text-xs font-semibold text-primary inline-flex items-center gap-1"><CheckCheck className="h-4 w-4" /> Mark all read</button>}
          <button onClick={n.clearRead} data-testid="notif-clear-read" className="text-xs font-semibold text-slate-500 inline-flex items-center gap-1"><Trash2 className="h-4 w-4" /> Clear read</button>
        </div>
      </div>
      <NotificationFilters filter={n.filter} setFilter={n.setFilter} counts={n.data.categories} testPrefix="mobile-notif" />
      {empty ? (
        <div className="text-center py-16 text-slate-400"><BellOff className="h-8 w-8 mx-auto mb-2" /><div className="text-sm">You're all caught up.</div></div>
      ) : (
        <div className="rounded-2xl border border-slate-100 bg-white overflow-hidden">
          <NotificationFeed items={n.data.items} onOpen={open} onToggleRead={n.toggleRead} onDismiss={n.dismiss} onAct={n.act} touch empty="No notifications match this filter." />
        </div>
      )}
      {n.data.items.length < n.data.total && (
        <button data-testid="mobile-notif-load-more" onClick={n.loadMore} disabled={n.busy} className="w-full py-2.5 rounded-xl border border-slate-200 text-sm font-semibold text-slate-600 disabled:opacity-60">{n.busy ? "Loading…" : "Load more"}</button>
      )}
    </div>
  );
}
